import { Currencies } from 'app/appState/model/types';
import { CreditNote } from 'entities/CreditNote';
import { DepositRefundNote } from 'entities/Deposit';
import { DocumentType, Invoice } from 'entities/Invoice';
import { User } from 'entities/User';

export enum PaymentProcessor {
  STRIPE = 'stripe',
  PAYPAL = 'payPal',
  AUTOPAY = 'autopay',
  SEPA = 'sepa_debit',
  BANK_TRANSFER = 'bank_transfer',
  OTHER = 'other', // Duplicate of bank transfer
  CASH = 'cash',
}

export enum PaymentMethod {
  ONLINE_PAYMENT = 'online_payment',
  BANK_TRANSFER = 'bank_transfer',
  USER_BALANCE = 'user_balance',
  OTHER = 'other',
  CASH = 'cash',
  TERMINAL_PAYMENT = 'terminal_payment',
  STRIPE_AUTO = 'stripe_auto',
}

export enum PaymentStatus {
  COMPLETED = 'Completed',
  REFUND_IN_PROGRESS = 'Refund in progress',
  REFUNDED = 'Refunded',
  REFUND_ERROR = 'Refund error',
}

export interface Refund {
  refundId: string;
  paymentMethod: PaymentProcessor;
  transactionId: string;
  currency: string;
  amount: number;
  documentNumber: string;
  documentType: DocumentType;
  description?: string;
  createdAt: string;
}

export interface Payment {
  paymentId: string;
  user: User;
  paymentMethod: PaymentProcessor;
  transactionId: string;
  currency: string;
  documentNumber: string;
  documentType: DocumentType;
  invoice: Invoice;
  amount: number;
  maxRefundAmount: Nullable<number>;
  description?: string;
  creditNote?: CreditNote;
  refund?: Refund;
  depositRefundNote?: DepositRefundNote;
  paymentStatus: PaymentStatus;
  refundedBy: Nullable<User>;
  markedAsPaidBy: Nullable<User>;
  createdAt: string;
  isReceiptIssued: boolean;
}

export interface PaymentParams {
  paymentId: string;
  description?: Nullable<string>;
}

export interface MarkAsRefundedPaymentParams extends PaymentParams {
  paymentMethod: string;
  amount: number;
  isDepositRefund?: boolean;
}

export interface CreditAndRefundPaymentParams extends MarkAsRefundedPaymentParams {}

export interface CreditPaymentParams extends PaymentParams {
  creditedAmount: number;
  addUserBalance?: boolean;
}

export interface PaymentResponse {
  redirectionUrl: string;
  paymentData?: CustomAny;
}

export interface PaymentMethodSetting {
  name: PaymentMethod;
  isAutoPaymentAllowed: boolean;
  imageUrl?: string;
}
